import { TmdxResourceCard } from '@features/components/ResourceCards';
import { Uuid } from '@/api/types';
import { useAircraftsById } from '@/queries/resource/availability';

type AircraftCardProps = {
  aircraftId: Uuid;
};

export const AircraftCard = ({ aircraftId }: AircraftCardProps) => {
  const { data } = useAircraftsById({ aircraftIds: aircraftId });
  const aircraft = data?.[0];

  if (!aircraft) return null;

  return (
    <div key={aircraft.id} className="w-80">
      <TmdxResourceCard
        menuDisabled
        list={[]}
        type="user"
        title={aircraft.registration}
        subTitle="Aircraft"
        phoneNumber=""
        showChip={false}
        avatarProps={{
          type: 'transport',
        }}
      />
    </div>
  );
};
